module.exports = __webpack_public_path__ + "img/116.c522164d.jpg";